
import { defineComponent, PropType, ref, toRefs, watch, reactive } from "vue";
import { ElPagination } from "element-plus";

import { AlbumModel, ArtistModel, CommentModel, CommentTargetType } from "@/typings";
import { getCommentList, CommentCreateInfo } from "@/services";
import CommentListItem from "@/components/Comment/CommentListItem.vue";
import CreateComment from "@/components/Comment/CreateComment.vue";

export default defineComponent({
    components: {
        ElPagination,
        CommentListItem,
        CreateComment,
    },
    props: {
        targetId: {
            type: String,
            required: true,
            default: "",
        },
        targetType: {
            type: String as PropType<CommentTargetType>,
            required: true,
            default: "ALBUM",
        },
        scopeType: {
            type: String,
            default: "full",
        },
        commentInfo: {
            type: Object as PropType<CommentCreateInfo>,
            required: false,
            default: null,
        },
    },
    setup(props) {
        const { targetType, targetId, scopeType } = toRefs(props);
        const comments = ref<CommentModel[]>([]);
        const loadings = reactive({
            main: false,
        });
        const paginationVersions = reactive({
            pageNow: 1,
            total: 0,
        });

        const refreshData = () => {
            if (targetType.value !== "ALL" && targetId.value === "") {
                return;
            }
            getCommentList(targetType.value, targetId.value, {
                page: paginationVersions.pageNow,
                scopeType: scopeType.value,
            })
                .then((json) => {
                    comments.value = json.data.comments;
                    paginationVersions.total = json.data.pages.total;
                })
                .finally(() => {
                    loadings.main = false;
                });
        };
        const pushNewComment = (comment: CommentModel) => {
            comments.value.unshift(comment);
        };
        watch(
            () => {
                return {
                    targetType,
                    targetId,
                };
            },
            refreshData,
            {
                immediate: true,
            },
        );

        return {
            paginationVersions,
            comments,
            pushNewComment,
            loadings,
        };
    },
});
